ProductReviews = window.ProductReviews ?= {}
ProductReviews.Views ?= {}
ProductReviews.Templates ?= {}

ProductReviews.Helpers = require '../../common/helpers'
ProductReviews.Templates['product_review_histogram'] = require '../../histogram.html.mustache'
ProductReviews.Templates['product_reviews_histogram_star'] = require '../../histogram_star.html.mustache'

ProductReviews.Views.Histogram = Backbone.View.extend
  el: '#product-reviews-histogram'
  template: ProductReviews.Templates['product_review_histogram']
  partials:
    product_reviews_histogram_star: ProductReviews.Templates['product_reviews_histogram_star']

  render: ->
    i18n = I18n.scoped()
    i18n.scope = ['js', 'modules', 'product_reviews']

    product = ProductReviews.Helpers.extractStats @options, i18n
    data =
      averageRating: ProductReviews.Helpers.averageRatingText product.averageRating, product.ratingCount, product.reviewCount, product.reviewsSorting, i18n
      histogram: ProductReviews.Helpers.buildHistogram product.ratingCount, product.ratingDistribution, i18n

    @$el.html @template.render(data, @partials)


module.exports = ProductReviews.Views.Histogram
